import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { is } from '@wp-g2/utils';
import { createContext, useContext, useRef } from 'react';
import { COLOR_BLIND_MODE_ATTR_PROP, DARK_MODE_ATTR_PROP, HIGH_CONTRAST_MODE_ATTR_PROP, REDUCED_MOTION_MODE_ATTR_PROP } from '../../create-style-system/constants';
export var ThemeProviderContext = /*#__PURE__*/createContext({
  isDark: null,
  isColorBlind: null,
  isReducedMotion: null,
  isHighContrast: null
});
export var useThemeProviderContext = function () {
  return useContext(ThemeProviderContext);
};
/**
 * Combines parent ThemeProvider context values with the current ThemeProvider
 * context values. This mechanism allows for "mode" settings to cascade
 * throughout the React component render tree.
 */

export function useThemeProviderContextBridge(currentContextState) {
  if (currentContextState === void 0) {
    currentContextState = {};
  }

  var parentThemeProviderContextState = useThemeProviderContext();
  var nextContextState = useRef(_objectSpread({}, parentThemeProviderContextState)).current;

  for (var _i = 0, _Object$entries = Object.entries(currentContextState); _i < _Object$entries.length; _i++) {
    var _ref3 = _Object$entries[_i];

    var _ref2 = _slicedToArray(_ref3, 2);

    var key = _ref2[0];
    var value = _ref2[1];

    if (is.defined(value)) {
      nextContextState[key] = value;
    }
  }

  return nextContextState;
}
/**
 * Creates HTML attributes corresponding to ThemeProvider modes.
 */

export function useThemeProviderModeHtmlAttributes(currentContextState) {
  if (currentContextState === void 0) {
    currentContextState = {};
  }

  var _currentContextState = currentContextState,
      isColorBlind = _currentContextState.isColorBlind,
      isDark = _currentContextState.isDark,
      isHighContrast = _currentContextState.isHighContrast,
      isReducedMotion = _currentContextState.isReducedMotion;
  var htmlAttrs = {};

  if (isDark) {
    htmlAttrs[DARK_MODE_ATTR_PROP] = 'dark';
  }

  if (isHighContrast) {
    htmlAttrs[HIGH_CONTRAST_MODE_ATTR_PROP] = true;
  }

  if (isColorBlind) {
    htmlAttrs[COLOR_BLIND_MODE_ATTR_PROP] = true;
  }

  if (isReducedMotion) {
    htmlAttrs[REDUCED_MOTION_MODE_ATTR_PROP] = true;
  }

  return htmlAttrs;
}